import { Injectable, Signal, signal } from "@angular/core";

@Injectable({
  providedIn: "root"})
export class LoaderService {
  private _loading = signal<boolean>(false);

  get loading(): Signal<boolean> {
    return this._loading;
  }

  show(): void {
    this._loading.set(true);
  }

  hide(): void {
    this._loading.set(false);
  }
}
